import { find, findKey, map, filter } from 'lodash';

class CategoryFormController {
    constructor($rootScope, $scope, $state, categoriesService, messageService, categoryAssignService, markdownService, configService) {
        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.categoriesService = categoriesService;
        this.categoryAssignService = categoryAssignService;
        this.messageService = messageService;
        this.configService = configService;
        this.marked = markdownService;
    }

    $onInit () {
        this.expand = true;

        this.category.parent = find(this.categories.data, { 'id': parseInt(this.category.parent, 10) });

        this.category = this.category || {};

        this.category.spadays = this.category.spadays || [];
        this.category.treatments = this.category.treatments || [];

        this.sanitise();
        this.category.property_id = this.category.property_id || this.$rootScope.currentProperty.id;
        this.treatmentDrag = {
            accept: function (sourceItemHandleScope, destSortableScope) {
                return !('day' in sourceItemHandleScope.itemScope.modelValue);
            },
            containment: '#treatmentlist',
            containerPositioning: 'relative',
            orderChanged: function (event) {
                if (event.source.sortableScope.$parent.$ctrl.category.id) {
                    event.source.sortableScope.$parent.$ctrl.saveTreatmentPosition();
                }
            }
        };
        this.dayDrag = {
            accept: function (sourceItemHandleScope, destSortableScope) {
                return !('treatment' in sourceItemHandleScope.itemScope.modelValue);
            },
            containment: '#daylist',
            containerPositioning: 'relative',
            orderChanged: function (event) {
                if (event.source.sortableScope.$parent.$ctrl.category.id) {
                    event.source.sortableScope.$parent.$ctrl.saveDayPosition();
                }
            }
        };
    }

    onSave () {
        if (this.category.id) {
            this.category.spadays = undefined;
            this.category.treatments = undefined;
        }
        if (this.category.parent) this.category.parent = { 'id': this.category.parent.id, 'level': this.category.parent.level };

        return this.categoriesService.save(this.category)
            .then(response => {
                if (this.category.updated_at) {
                    this.messageService.success(`The category <strong>${this.category.name}</strong> was successfully updated!`);
                } else {
                    this.messageService.success(`The category <strong>${this.category.name}</strong> was successfully created.`, [`app.admin.category-edit({ 'category' : ${response.id}})`, `Category`]);
                }
            })
            .then(() => {
                this.messageService.clear();
                this.$state.go('app.admin.categories');
            });
    }

    unassignTreatment (treatment) {
        this.categoryAssignService.unassignTreatment(treatment.id, this.category.id)
            .catch(error => {
                this.messageService.failure(`The treatment <strong>${treatment.name}</strong> could not be successfully removed: ${error.statusText}`);
                this.messageService.push();
            })
            .then(response => {
                this.category.treatments.splice(findKey(this.category.treatments, assignment => assignment.related_event.id === treatment.id), 1);
            });
    }

    unassignDay (day) {
        this.categoryAssignService.unassignDay(day.id, this.category.id)
            .catch(error => {
                this.messageService.failure(`The treatment <strong>${day.name}</strong> could not be successfully removed: ${error.statusText}`);
                this.messageService.push();
            })
            .then(response => {
                this.category.spadays.splice(findKey(this.category.spadays, assignment => assignment.related_event.id === day.id), 1);
            });
    }

    validDays (item) {
        return findKey(this.category.spadays, innerday => innerday.related_event.id === item.id);
    }

    validTreatments (item) {
        return findKey(this.category.treatments, innertreatment => innertreatment.related_event.id === item.id);
    }

    validCategories () {
        return item => !findKey(this.categories, innercategory => innercategory.id === this.category.id);
    }

    addDay () {
        if (this.selectedday) {
            this.selectedday = this.selectedday.id;
            let day = find(this.days, { 'id': this.selectedday });
            this.category.spadays.push({ 'related_event_type': 'App\\SpaDay', 'related_event_id': day.id, 'related_event': day });
            if (this.category.id) {
                this.categoryAssignService.assignDay(this.selectedday, this.category.id, this.forcePrimary)
                    .catch(error => {
                        this.messageService.failure(`The treatment <strong>${day.name}</strong> could not be successfully added: ${error.statusText}`);
                        this.messageService.push();
                        this.category.spadays.splice(findKey(this.category.spadays, assignment => assignment.day.id === this.selectedday), 1);
                    }).then(() => this.selectedday = '');
            } else {
                this.selectedday = '';
            }
        }
    }

    addTreatment () {
        if (this.selectedtreatment) {
            this.selectedtreatment = this.selectedtreatment.id;
            let treatment = find(this.treatments, { 'id': this.selectedtreatment });
            this.category.treatments.push({ 'related_event_type': 'App\\Treatment', 'related_event_id': treatment.id, 'related_event': treatment });
            if (this.category.id) {
                this.categoryAssignService.assignTreatment(this.selectedtreatment, this.category.id, this.forcePrimary)
                    .catch(error => {
                        this.messageService.failure(`The treatment <strong>${day.name}</strong> could not be successfully added: ${error.statusText}`);
                        this.messageService.push();
                        this.category.treatments.splice(findKey(this.category.treatments, assignment => assignment.treatment.id === this.selectedtreatment), 1);
                    }).then(() => this.selectedtreatment = '');
            } else {
                this.selectedtreatment = '';
            }
        }
    }

    saveTreatmentPosition () {
        this.categoryAssignService.reorderTreatments(map(this.category.treatments, treatment => treatment.related_event.id), this.category.id)
            .catch(error => {
                this.messageService.failure(`The treatment order could not be successfully saved: ${error.statusText}`);
                this.messageService.push();
            });
    }

    saveDayPosition () {
        this.categoryAssignService.reorderDays(map(this.category.spadays, day => day.related_event.id), this.category.id)
            .catch(error => {
                this.messageService.failure(`The spa day order could not be successfully saved: ${error.statusText}`);
                this.messageService.push();
            });
    }

    sanitise () {
        this.category.spadays = filter(this.category.spadays, { 'event_category_id': this.category.id });
        this.category.treatments = filter(this.category.treatments, { 'event_category_id': this.category.id });
    }

    initialSlug () {
        if (!this.category.id && document.getElementsByClassName('inline')[0].className.includes('untouched')) {
            this.category.slug = (this.category.name ? this.category.name.replace(/[^a-zA-Z\d\s]+/g, '').replace(/[ ]+/g, '-').replace(/--+/g, '-').toLowerCase() : '');
        }
    }
}

CategoryFormController.$inject = ['$rootScope', '$scope', '$state', 'categoriesService', 'messageService', 'categoryAssignService', 'markdownService', 'configService'];

export default CategoryFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/category.form.controller.js